import { gql } from '@apollo/client';

export const GET_VOLUNTEERS_ROLE_APPLICATIONS = gql`
  query GetVolunteersRoleApplications {
    vm {
      activeRoleApplications {
        roleApplicationId
        status
        dateApplied
        dateActioned
        firstApprovedAt
        actionReason
        tasksTotal
        tasksCompleted
        applicableTasks {
          taskId
          title
        }
        role {
          activityRoleId
          name
          icon
        }
        volunteer {
          volunteerId
          dateDeactivated
          profile {
            profileId
            userId
            firstName
            preferredName
            lastName
            email
            contactNumber
            avatarUrl
            completedTasks {
              completedTaskId
              status
              dateSubmitted
              task {
                taskId
              }
            }
          }
        }
      }
    }
  }
`;
